import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// The fields every record screen reads, written once so the diary and the
// daily record ask for exactly the same shape.
export const recordFields = `
  date mood anxiety irritability sleepHours weightKg completeness
  medicationEntries { entry medication { id name doseMg } }
`;

// The patient's records from `from` to `to`, one per day, re-read whenever
// the range changes. days is undefined until the answer for this very range
// arrives, so a screen can tell "loading" from "an empty range" and never
// renders the previous range's days for the new one; useLoad drops an answer
// for a range the screen has already left. error and retry are useLoad's.
export function useRecords({ from, to }) {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query Records($from: String!, $to: String!) { dailyRecords(from: $from, to: $to) { ${ recordFields } } }`,
      variables: { from, to }
    }).then(function(data) {
      return data.dailyRecords;
    });
  }, [ graphql, from, to ]);

  const { data, error, retry } = useLoad(read);

  return useMemo(function() {
    return { days: data, error, retry };
  }, [ data, error, retry ]);
}
